@if (level == "1") {
  <h1 [className]="value" [ngStyle]="styles">{{ text }}</h1>
}
@if (level == "2") {
  <h2 [className]="value" [ngStyle]="styles">{{ text }}</h2>
}
@if (level == "3") {
  <h3 [className]="value" [ngStyle]="styles">{{ text }}</h3>
}
@if (level == "4") {
  <h4 [className]="value" [ngStyle]="styles">{{ text }}</h4>
}
@if (level == "5") {
  <h5 [className]="value" [ngStyle]="styles">{{ text }}</h5>
}
@if (level == "6") {
  <h6 [className]="value" [ngStyle]="styles">{{ text }}</h6>
}
